import { createContext, useCallback, useEffect, useMemo, useState } from 'react'
import { getBusinessSettings, saveBusinessSettings } from '../services/businessSettings.service'

const BusinessSettingsContext = createContext(null)

export const BusinessSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refetch = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getBusinessSettings()
      setSettings(data)
    } catch (e) {
      setError(e?.message || 'Error cargando configuración comercial')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refetch()
  }, [refetch])

  const update = useCallback(async (nextSettings) => {
    await saveBusinessSettings(nextSettings)
    setSettings(nextSettings)
  }, [])

  const activeProfile = useMemo(() => {
    if (!settings) return null
    return settings.active || { rubro: 'muebles', subrubro: null, designId: 'muebles/v1' }
  }, [settings])

  const value = useMemo(() => ({
    settings,
    loading,
    error,
    activeProfile,
    refetch,
    update
  }), [settings, loading, error, activeProfile, refetch, update])

  return (
    <BusinessSettingsContext.Provider value={value}>
      {children}
    </BusinessSettingsContext.Provider>
  )
}

export default BusinessSettingsContext
